import { makeAutoObservable, runInAction } from "mobx";
import agent from "../api/agent";

export default class ProjectMemberStore {
  members = [];
  loading = false;

  constructor(rootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, {}, { autoBind: true });
  }

  async fetchMembers(projectId) {
    if (!projectId) return;
    runInAction(() => { this.loading = true; });
    try {
      const response = await agent.Projects.listMembers(projectId);
      runInAction(() => { this.members = response || []; });
    } catch (err) {
      console.error("Failed to load project members:", err);
      runInAction(() => { this.members = []; });
    } finally {
      runInAction(() => { this.loading = false; });
    }
  }

  async addMember(projectId, email, role) {
    try {
      const payload = { userEmail: email, role };
      const result = await agent.Projects.addMember(projectId, payload);
      if (result !== null) {
        await this.fetchMembers(projectId);
      }
      return result;
    } catch (err) {
      console.error("Failed to add member:", err);
      return null;
    }
  }

  async removeMember(projectId, email) {
    try {
      const result = await agent.Projects.removeMember(projectId, email);
      if (result !== null) {
        await this.fetchMembers(projectId);
      }
      return result;
    } catch (err) {
      console.error("Failed to remove member:", err);
      return null;
    }
  }
}
